import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Owner from "./components/Owner";
import Services from "./components/Services";
import Catalogue from "./components/Catalogue";
import Reels from "./components/Reels";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import RebrandModal from "./components/RebrandModal";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

function Home() {
  return (
    <div className="font-sans bg-cream text-gray-900 overflow-x-hidden">
      <RebrandModal />
      <Header />
      <main>
        <Hero />
        <About />
        <Owner />
        <Services />
        <Catalogue />
        <Reels />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
